import { defineMessages } from 'react-intl'

export default defineMessages({
  createSpace: {
    id: 'OrganizationSettings.Spaces.CreateSpace',
    defaultMessage: 'Create Space'
  },
  title: {
    id: 'OrganizationSpacesPage.Title',
    defaultMessage: 'Spaces'
  }
})
